import { ApiResourceBaseClass as i } from "./baseApiCalls.js";
const a = "review_booster";
class o extends i {
  /**
   * Sends a Review Booster invitation
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_booster/send_invitation`
   *
   * @param {SendInvitationData} invitationData - The invitation data
   */
  sendInvitation = async (t) => {
    const { data: e } = await this.post(
      `${a}/send_invitation`,
      t
    );
    return e;
  };
  /**
   * Gets the name of the SMS expeditor (aka the Sender ID) for a given business
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_booster/expeditor`
   *
   * @param {string} businessId - The id of the business to get the expeditor name from
   */
  getExpeditorName = async (t) => {
    const { data: e } = await this.get(`${a}/expeditor`, {
      business_id: t
    });
    return e;
  };
  /**
   * Gets the URL to leave a review for a given business
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_booster/get_review_url/:business_id`
   *
   * @param {string} businessId - The id of the business to get the review URL from
   * @param {boolean} minifyUrl - Whether to get a short url (defaults to false)
   */
  getReviewUrl = async (t, e = !1) => {
    try {
      const { data: s } = await this.get(
        `${a}/get_review_url/${t}?minify_url=${e}`
      );
      return s;
    } catch {
      return { review_url: "" };
    }
  };
  /**
   * @deprecated
   *
   * Update the name of the SMS expeditor (aka the Sender ID)
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_booster/expeditor`
   *
   * @param {UpdateExpeditorData} updateExpeditorData
   */
  updateExpeditorName = async (t) => {
    const { data: e } = await this.post(
      `${a}/expeditor`,
      t
    );
    return e;
  };
  /**
   * Get a user's Review Booster template
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_booster/template`
   *
   * @param {number} templateId - The ID of the user's template
   */
  getTemplate = async (t) => {
    const { data: e } = await this.get(
      `${a}/template`,
      t ? { template_id: t } : void 0
    );
    return e;
  };
  /**
   * Updates the user's Review Booster template
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/review_booster/template`
   *
   * @param {string} template - The content of the template
   */
  updateTemplate = async (t) => {
    const { data: e } = await this.put(`${a}/template`, {
      template: t
    });
    return e;
  };
}
export {
  o as ReviewBooster
};
